import React from 'react'

export const Review = () => {
  return (
    <div className=' bg-gray-100 flex-1 overflow-auto'>
    <div className='bg-white p-4 rounded shadow-md'>
      <h2 className='text-2xl font-semibold'>Review</h2>
      <p className='mt-4 text-gray-600'>Coming Soon</p>
    </div>
  </div>
  )
}
